export const getPreparedData = formData => {
  const reward: any = {};
  const { temp, ...formDataWithoutTemp } = formData;
  for (const i in formDataWithoutTemp) {
    if (Object.prototype.hasOwnProperty.call(formData, i) && formData[i] !== null) {
      // NaN is falsy all falsy including 0 just evaluate to 0, will not be NaN bcz number input but jz in case
      reward[i] = i === 'new_budget' ? Number(formData[i]) || 0 : formData[i];
    }
  }
  switch (reward.transaction_validity_period_type) {
    case 'period':
      reward.transaction_expires_in_units = null;
      reward.grace_time_in_units = null;
      break;
    case 'issuance_date':
      reward.grace_time_in_units = null;
      reward.transaction_issues_at = null;
      reward.transaction_issues_at_time = null;
      reward.transaction_expires_at = null;
      reward.transaction_expires_at_time = null;
      break;
    case 'end_of_month':
      reward.transaction_expires_in_units = null;
      reward.transaction_issues_at = null;
      reward.transaction_issues_at_time = null;
      reward.transaction_expires_at = null;
      reward.transaction_expires_at_time = null;
      break;
    default:
      break;
  }
  // more clean up payload than validation
  if (reward?.['reward_prices']) {
    // remove invalid selling prices, including null and undefined
    const safe_prices = reward?.['reward_prices'].filter(({ price, points }) =>
      points ? points : price
    );
    // points just price field that are invalid
    reward['reward_prices'] = safe_prices.map(({ price, ...others }) =>
      price ? { price, ...others } : others
    );
  }
  return reward;
};
